@file:OptIn(InternalResourceApi::class)

package portfolio.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portfolio.shared.generated.resources/"

@delegate:ResourceContentHash(820_373_606)
internal val Res.drawable.app_store_logo: DrawableResource by lazy {
      DrawableResource("drawable:app_store_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_store_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-749_363_329)
internal val Res.drawable.bober_template: DrawableResource by lazy {
      DrawableResource("drawable:bober_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/bober_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_541_502_360)
internal val Res.drawable.coinway_template: DrawableResource by lazy {
      DrawableResource("drawable:coinway_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/coinway_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(117_712_599)
internal val Res.drawable.cotam_template: DrawableResource by lazy {
      DrawableResource("drawable:cotam_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/cotam_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(356_613_560)
internal val Res.drawable.durak_template: DrawableResource by lazy {
      DrawableResource("drawable:durak_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/durak_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_239_728_990)
internal val Res.drawable.github_logo: DrawableResource by lazy {
      DrawableResource("drawable:github_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/github_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_419_871_562)
internal val Res.drawable.github_logo_org: DrawableResource by lazy {
      DrawableResource("drawable:github_logo_org", setOf(
        ResourceItem(setOf(), "${MD}drawable/github_logo_org.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_105_917_196)
internal val Res.drawable.google_play_logo: DrawableResource by lazy {
      DrawableResource("drawable:google_play_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/google_play_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_725_430_016)
internal val Res.drawable.google_play_logo_org: DrawableResource by lazy {
      DrawableResource("drawable:google_play_logo_org", setOf(
        ResourceItem(setOf(), "${MD}drawable/google_play_logo_org.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(831_312_322)
internal val Res.drawable.guessy_template: DrawableResource by lazy {
      DrawableResource("drawable:guessy_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/guessy_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(89_422_959)
internal val Res.drawable.ic_location: DrawableResource by lazy {
      DrawableResource("drawable:ic_location", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_location.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_070_890_144)
internal val Res.drawable.ic_mail: DrawableResource by lazy {
      DrawableResource("drawable:ic_mail", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_mail.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_598_885_068)
internal val Res.drawable.ic_moon: DrawableResource by lazy {
      DrawableResource("drawable:ic_moon", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_moon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(375_385_577)
internal val Res.drawable.ic_phone: DrawableResource by lazy {
      DrawableResource("drawable:ic_phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_phone.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_351_157_503)
internal val Res.drawable.ic_sun: DrawableResource by lazy {
      DrawableResource("drawable:ic_sun", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sun.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(629_375_900)
internal val Res.drawable.linkedin_logo: DrawableResource by lazy {
      DrawableResource("drawable:linkedin_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin_logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(200_526_991)
internal val Res.drawable.linkedin_logo_org: DrawableResource by lazy {
      DrawableResource("drawable:linkedin_logo_org", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin_logo_org.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-736_392_230)
internal val Res.drawable.logo_bober: DrawableResource by lazy {
      DrawableResource("drawable:logo_bober", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_bober.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(983_401_573)
internal val Res.drawable.logo_coinway: DrawableResource by lazy {
      DrawableResource("drawable:logo_coinway", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_coinway.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_554_486_651)
internal val Res.drawable.logo_cotam: DrawableResource by lazy {
      DrawableResource("drawable:logo_cotam", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_cotam.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(374_969_638)
internal val Res.drawable.logo_durak: DrawableResource by lazy {
      DrawableResource("drawable:logo_durak", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_durak.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_985_449_184)
internal val Res.drawable.logo_github: DrawableResource by lazy {
      DrawableResource("drawable:logo_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(182_698_924)
internal val Res.drawable.logo_guessy: DrawableResource by lazy {
      DrawableResource("drawable:logo_guessy", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_guessy.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_182_967_911)
internal val Res.drawable.logo_linkedin: DrawableResource by lazy {
      DrawableResource("drawable:logo_linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_linkedin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(720_161_941)
internal val Res.drawable.logo_mapquiz: DrawableResource by lazy {
      DrawableResource("drawable:logo_mapquiz", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_mapquiz.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-154_612_752)
internal val Res.drawable.logo_movietime: DrawableResource by lazy {
      DrawableResource("drawable:logo_movietime", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_movietime.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(88_271_690)
internal val Res.drawable.logo_notefire: DrawableResource by lazy {
      DrawableResource("drawable:logo_notefire", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_notefire.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_057_735_175)
internal val Res.drawable.logo_notefire_cloud: DrawableResource by lazy {
      DrawableResource("drawable:logo_notefire_cloud", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_notefire_cloud.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-680_064_467)
internal val Res.drawable.logo_playstore: DrawableResource by lazy {
      DrawableResource("drawable:logo_playstore", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_playstore.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_318_397_827)
internal val Res.drawable.logo_polskismak: DrawableResource by lazy {
      DrawableResource("drawable:logo_polskismak", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_polskismak.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(88_989_998)
internal val Res.drawable.logo_postgram: DrawableResource by lazy {
      DrawableResource("drawable:logo_postgram", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_postgram.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_191_510_943)
internal val Res.drawable.logo_sunnyday: DrawableResource by lazy {
      DrawableResource("drawable:logo_sunnyday", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_sunnyday.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_050_468_438)
internal val Res.drawable.logo_zaureats: DrawableResource by lazy {
      DrawableResource("drawable:logo_zaureats", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_zaureats.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_378_751_658)
internal val Res.drawable.mapquiz_template: DrawableResource by lazy {
      DrawableResource("drawable:mapquiz_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/mapquiz_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_116_188_023)
internal val Res.drawable.movietime_template: DrawableResource by lazy {
      DrawableResource("drawable:movietime_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/movietime_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_593_859_409)
internal val Res.drawable.notefire_cloud_template: DrawableResource by lazy {
      DrawableResource("drawable:notefire_cloud_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/notefire_cloud_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-638_227_633)
internal val Res.drawable.notefire_template: DrawableResource by lazy {
      DrawableResource("drawable:notefire_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/notefire_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_676_471_597)
internal val Res.drawable.polskismak_template: DrawableResource by lazy {
      DrawableResource("drawable:polskismak_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/polskismak_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(463_427_529)
internal val Res.drawable.postgram_template: DrawableResource by lazy {
      DrawableResource("drawable:postgram_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/postgram_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-167_470_974)
internal val Res.drawable.sunnyday_template: DrawableResource by lazy {
      DrawableResource("drawable:sunnyday_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/sunnyday_template.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_499_401_035)
internal val Res.drawable.zaureats_template: DrawableResource by lazy {
      DrawableResource("drawable:zaureats_template", setOf(
        ResourceItem(setOf(), "${MD}drawable/zaureats_template.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_store_logo", Res.drawable.app_store_logo)
  map.put("bober_template", Res.drawable.bober_template)
  map.put("coinway_template", Res.drawable.coinway_template)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("cotam_template", Res.drawable.cotam_template)
  map.put("durak_template", Res.drawable.durak_template)
  map.put("github_logo", Res.drawable.github_logo)
  map.put("github_logo_org", Res.drawable.github_logo_org)
  map.put("google_play_logo", Res.drawable.google_play_logo)
  map.put("google_play_logo_org", Res.drawable.google_play_logo_org)
  map.put("guessy_template", Res.drawable.guessy_template)
  map.put("ic_location", Res.drawable.ic_location)
  map.put("ic_mail", Res.drawable.ic_mail)
  map.put("ic_moon", Res.drawable.ic_moon)
  map.put("ic_phone", Res.drawable.ic_phone)
  map.put("ic_sun", Res.drawable.ic_sun)
  map.put("linkedin_logo", Res.drawable.linkedin_logo)
  map.put("linkedin_logo_org", Res.drawable.linkedin_logo_org)
  map.put("logo_bober", Res.drawable.logo_bober)
  map.put("logo_coinway", Res.drawable.logo_coinway)
  map.put("logo_cotam", Res.drawable.logo_cotam)
  map.put("logo_durak", Res.drawable.logo_durak)
  map.put("logo_github", Res.drawable.logo_github)
  map.put("logo_guessy", Res.drawable.logo_guessy)
  map.put("logo_linkedin", Res.drawable.logo_linkedin)
  map.put("logo_mapquiz", Res.drawable.logo_mapquiz)
  map.put("logo_movietime", Res.drawable.logo_movietime)
  map.put("logo_notefire", Res.drawable.logo_notefire)
  map.put("logo_notefire_cloud", Res.drawable.logo_notefire_cloud)
  map.put("logo_playstore", Res.drawable.logo_playstore)
  map.put("logo_polskismak", Res.drawable.logo_polskismak)
  map.put("logo_postgram", Res.drawable.logo_postgram)
  map.put("logo_sunnyday", Res.drawable.logo_sunnyday)
  map.put("logo_zaureats", Res.drawable.logo_zaureats)
  map.put("mapquiz_template", Res.drawable.mapquiz_template)
  map.put("movietime_template", Res.drawable.movietime_template)
  map.put("notefire_cloud_template", Res.drawable.notefire_cloud_template)
  map.put("notefire_template", Res.drawable.notefire_template)
  map.put("polskismak_template", Res.drawable.polskismak_template)
  map.put("postgram_template", Res.drawable.postgram_template)
  map.put("sunnyday_template", Res.drawable.sunnyday_template)
  map.put("zaureats_template", Res.drawable.zaureats_template)
}
